import { RouteRecordRaw } from "vue-router";
import { AuthGuardService } from "@/_guard/AuthGuardService";

import tokensLayout from "@/modules/tokens/views/viewTokensIndex.vue";

import listTokens from "@/modules/tokens/views/viewTokensList.vue";
import createToken from "@/modules/tokens/views/viewTokensCreate.vue";
import updateToken from "@/modules/tokens/views/viewTokensUpdate.vue";


const auth = new AuthGuardService();

export const TokensRoutes: RouteRecordRaw[] = [
  {
    path: "/tokens",
    name: "viewTokensIndex",
    component: tokensLayout,
    beforeEnter: auth.guard,
    children: [
      {
        path: '',
        name: 'viewTokensList',
        meta: {title: 'Tokens'},
        component: listTokens
      },
      {
        path: '/create-token/:network',
        name: 'viewTokensCreate',
        meta: {title: 'Create Tokens'},
        component: createToken
      },
      {
        path: '/update-token/:testnetTokenId/:mainnetTokenId?',
        name: 'viewTokensUpdate',
        meta: {title: 'Update Tokens'},
        component: updateToken
      },
    ]
  },
];